import { render, staticRenderFns } from "./TableExtra.vue?vue&type=template&id=2be09744&scoped=true&"
import script from "./TableExtra.vue?vue&type=script&lang=js&"
export * from "./TableExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be09744",
  null
  
)

export default component.exports